import Loadable from '../../../../../components/loadable';

export default Loadable(() =>
  import(
    /* webpackChunkName: "business-showcase-skincare-hd-diagnostics" */ './index'
  )
);
